module.exports = __webpack_public_path__ + "static/media/arrows-up.d5e67f28.svg";